import React, { useState } from "react";

/// React router dom
import { Link, useLocation } from "react-router-dom";

/// images
import logo from "../../../../src/logo-icon.svg";
import logoText from "../../../../src/logo-text.svg";

export function NavMenuToggle(close = false) {
   setTimeout(() => {
      let mainwrapper = document.querySelector("#main-wrapper");
      if (close) {
         // Force close menu
         mainwrapper.classList.remove("menu-toggle");
      } else {
         // Toggle menu state
         if (mainwrapper.classList.contains("menu-toggle")) {
            mainwrapper.classList.remove("menu-toggle");
         } else {
            mainwrapper.classList.add("menu-toggle");
         }
      }
   }, 200);
}

const NavHader = () => {
   const [toggle, setToggle] = useState(false);
   const location = useLocation();

   // Close the menu on route change
   React.useEffect(() => {
      setToggle(false); // Reset toggle state
      NavMenuToggle(true); // Close menu
   }, [location.pathname]); // Trigger effect on location change

   return (
      <div className="nav-header">
         <Link to="/" className="brand-logo">
            <img className="logo-abbr" src={logo} alt="" />
            <img className="logo-compact" src={logoText} alt="" />
            <img className="brand-title" src={logoText} alt="" />
         </Link>

         <div
            className="nav-control"
            onClick={() => {
               setToggle(!toggle);
               NavMenuToggle();
            }}
         >
            <div className={`hamburger ${toggle ? "is-active" : ""}`}>
               <span className="line"></span>
               <span className="line"></span>
               <span className="line"></span>
            </div>
         </div>
      </div>
   );
};

export default NavHader;